module.exports = __webpack_public_path__ + "static/media/0027.bab27b11.jpg";